const FetchError = "Failed to fetch data. Please try again later.";
const Error = "Error fetching data :";
export { FetchError, Error };
